import useGame from './stores/useGame.js'
import { useEffect, useState, useRef } from 'react'
import { useSpring, animated } from '@react-spring/web'

export default function Interface()
{
    const space = useGame((state) => state.space)
    const transitionDone = useGame((state) => state.transitionDone)
    const setTransitionDone = useGame((state) => state.setTransitionDone)

    const informaatio = useGame((state) => state.informaatio)
    const julkaisut = useGame((state) => state.julkaisut)
    const ulkomainokset = useGame((state) => state.ulkomainokset)
    const installaatiot = useGame((state) => state.installaatiot)
    const livevisuals = useGame((state) => state.livevisuals)
 
    const startBgMusic = useGame((state) => state.startBgMusic)
    const setStartBgMusic = useGame((state) => state.setStartBgMusic)

    const [visible, setVisible] = useState(false)

    // Show black screen whenever a transition starts
    useEffect(() => {
        if (!transitionDone) {
            setVisible(true)
        }
    }, [transitionDone])

    // Hide black screen when transition finishes
    useEffect(() => {
        if (transitionDone) {
            setVisible(false)
        }
    }, [transitionDone, setTransitionDone])

    const styles = useSpring({
        opacity: visible ? 1 : 0,
        config: { tension: 700, friction: 80 },
    })

    return <>

    <div className="interface">
        <div className="wall" onClick={informaatio}>INFO BOARD</div>
        <div className="table" onClick={julkaisut}>COFFEE TABLE</div>
        <div className="alley" onClick={ulkomainokset}>ALLEY</div>
        <div className="arthouse" onClick={installaatiot}>WALL</div>
        <div className="stage" onClick={livevisuals}>ARENA</div>
        <button className='mute-music' onClick={() => setStartBgMusic(!startBgMusic)}>
            {startBgMusic ? ( <img src="/Images/volumeOn.png" alt="O" style={{ width: '30px', height: '30px' }} />) 
            : (<img src="/Images/volumeOff.png" alt="X" style={{ width: '30px', height: '30px' }} />) }
        </button>
    
    
    </div>
    
          {/* Black screen overlay */}
      <animated.div
        style={{
          ...styles,
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'black',
          pointerEvents: 'none',
          zIndex: 10,
        }}
      />
</>
}